import React, { memo, PropsWithChildren } from 'react';

import { cn } from '@nextui-org/react';

interface IProps extends PropsWithChildren {
	className?: string;
}

const Wrapper: React.FC<IProps> = ({ children, className }) => {
	return (
		<section
			className={cn(
				'mx-auto w-full max-w-[1440px] px-4 py-2 lg:px-10 lg:py-3',
				className
			)}
		>
			{children}
		</section>
	);
};

export default memo(Wrapper);
